<template>
    <div :class="divPadding" class="flex items-center">
        <img v-bind:src="'https://firebasestorage.googleapis.com/v0/b/lesodec-a5808.appspot.com/o/lesodec%20(2).jfif?alt=media&token=cdbf25d0-3c29-4b8e-bf0e-fac10e9d0a89'" alt="icon" class="h-8 w-auto mr-4 rounded-full"/>
        <div :class="textClass" class="inline-block text-xl font-semibold uppercase">{{ $store.state.settings.name }}</div>
    </div>
</template>

<script>
export default {
    name: "logo",
    props: {
        divPadding: {
            type: String,
            default: 'px-4',
            required: false
        },
        textClass: {
            type: String,
            default: 'text-white',
            required: false
        }
    }
}
</script>
